﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260403
*/
'use strict';
import { getUTCDate } from './ctssFormat.js';
import { getPromise, savePromise } from './ctssJQuery.js';
import { getToken, parseToken, setToken, removeToken } from './ctssJWT.js';
    
const getSubscriptionStatusMsg = (params) => {
    if (params.token.IsCActive === "False") {
        const msg = `Your subscription has expired. Please go to Admin > Billing to update your payment information...`;
        $('#divSubscriptionExpiringMsg').text(msg).removeClass('hidden');
    } else if (params.token.CStatus === "3") {
        const msg = `Your subscription is past due. Please go to Admin > Billing to update your payment information...`;
        $('#divSubscriptionExpiringMsg').text(msg).removeClass('hidden');            
    } else {
        $('#divSubscriptionExpiringMsg').addClass('hidden');
    }
}
const setMenuProfile = (token) => {
    $('#menu-admin-greeting').text(token.FirstName);
    if (token.ProfileImgURL.length > 0) {
        $('#imgAdmin').prop('src', token.ProfileImgURL);
    }
}

const appDebugMode = false; // change to true to enable debug mode

const locationURL = window.location.origin; 
let adminPortalURL = '';
let baseURL = '';
if (locationURL.includes('localhost')) {
    adminPortalUrl = "https://localhost:44319";
    baseURL = "https://68x11sm6-7014.use2.devtunnels.ms";
}
else if (locationURL.includes('portal-dev')) { // "portal-dev.mysermonnotes.com"    
    adminPortalURL = "https://portal-dev.mysermonnotes.com";
    baseURL = "https://mysnwebapiv2-development-e0eug3fzaxceghdd.southcentralus-01.azurewebsites.net";
}
else if (locationURL.includes('portal-staging')) {
    adminPortalURL = "https://portal-staging.mysermonnotes.com";
    baseURL = "https://mysnwebapiv2-staging-aee3a7evddamewbu.southcentralus-01.azurewebsites.net";
}
else {
    adminPortalURL = "https://portal.mysermonnotes.com";
    baseURL = "https://api-v2.mysermonnotes.com";
}

/* All features will save a group id regardless of where    *
    * the church is implemented groups or not.  This is used   *
    * to ensure a smooth transition if the church decides to   *
    * implement groups later.  All previously entered rows     *
    * will have a group id of 0, which means the entire        *
    * congregation which is correct since there were no groups *
    * at that time                                             */

const defaultProfileImg = "https://mysermonnotes.blob.core.windows.net/images/ProfilePictures/ProfPicPlaceholder.jpg";

const entireCongregationGroupID   = 0; // used for group leader portal menu
const entireCongregationGroupName = 'Entire Congregation';
const entireCongregationGroupImgName = 'EntireCongregationPlaceholder.png';

const Features = Object.freeze({
    Sermons: 1,
    PrayerRequests: 3,
    Events: 6,
    Announcements: 11
});

const ImgsFolder = Object.freeze({
    TestFolder: -1,
    Announcements: 0,
    Events: 1,
    Features: 2,
    Groups: 3,
    Logos: 4,
    ProfilePictures: 5,
    SermonNotes: 6
});



const getImgsBaseURLAsync = async (imgsFolder, testFolderParam = '') =>
    await getPromise({ url: `Storage/ImgsBaseURL/${imgsFolder}${testFolderParam}` });

const getImgsFolder = (params = {}) => {
    const { featureID } = params;
    if (!featureID) {
        alert('featureID is a required parameter for snSite.getImgFolder');
        return;
    }
    switch (featureID) {
        case Features.Sermons: return ImgsFolder.SermonNotes;
        case Features.Announcements: return ImgsFolder.Announcements;
        case Features.Events: return ImgsFolder.Events;
        default: return ImgsFolder.TestFolder;
    }
}
const getTestFolderParams = (paramOperator = '?') => {
    const useTestFolder = false; // change to true to use test folder
    if (useTestFolder) {
        alert('Using test folder for images - Reset in snSite.getTestFolderParams()');
    }
    const testFolderParam = `${paramOperator}useTestFolder=${ useTestFolder ? 'true' : 'false'}`;

    return { useTestFolder, testFolderParam };
};
    
const getAppToken = (params = {}) => {

    const { tokenNm = 'sNotes' } = params;
    return parseToken({
        token: getToken({ tokenNm })
    });
}

const redirectToHomeURL = (params = {}) => {

    const { token = getAppToken() } = params;

    const home = (token.IsAdmin === 'True')
        ? '../Home'
        : (token.GroupLeaderRights.length > 0)
            ? '../Home/GroupLeaderPortalMenu'
            : '../Home/MemberPortalMenu';

    window.location.href = home;
}

const refreshTokenForSubscriptionStatusAsync = async (params) => {

    const status = await getPromise({
        url: 'Churches/SubscriptionStatus'
    });
    const retVal = await savePromise({
        url: 'Churches/RefreshSubscriptionStatus',
        data: status
    });

    const refreshedToken = retVal.token;
    removeToken({ tokenNm: params.tokenNm });
    setToken({ tokenNm: params.tokenNm, token: refreshedToken });
    getSubscriptionStatusMsg({ token: refreshedToken });
}

const setAuthHdr = (xhr) => {
    xhr.setRequestHeader('Authorization', 'bearer ' + getToken({ tokenNm: 'sNotes' }));
}

const setGroupLeaderPortalMenu = (token) => {

    if (token !== undefined) {

        let featureIDs = [];
        const groupData = token.GroupLeaderRights.split(',');
        for (let i = 0, l = groupData.length; i < l; i++) {
            const groupFeatureData = groupData[i].split('^')[1].split('|');
            for (let j = 0, l2 = groupFeatureData.length; j < l2; j++) {
                const featureID = parseInt(groupFeatureData[j]);
                if (featureIDs.includes(featureID) === false) {
                    featureIDs.push(featureID);
                }
            }
        }

        if (featureIDs.includes(Features.Sermons)) {
            $('#liSermons').removeClass('hidden');
        }
        if (featureIDs.includes(Features.Announcements)) {
            $('#liAnnouncements').removeClass('hidden');
        }
        if (featureIDs.includes(Features.Events)) {
            $('#liSchedule').removeClass('hidden');
        }
        if (featureIDs.includes(Features.PrayerRequests)) {
            $('#liPrayerRequests').removeClass('hidden');
        }
        $('#liAccount').removeClass('hidden');
        $('#liSignIn').addClass('hidden');
        setMenuProfile(token);
    } else {
        $('#liSermons,#liAnnouncments,#liSchedule,#liPrayerRequests,#liAccount').addClass('hidden');
        $('#liSignIn').removeClass('hidden');
    }
} 

const setMemberPortalMenu = (token) => {
    const options = '#liMySermons,#liMyAccount,#liAccount';
    if (token !== undefined) {
        $(options).removeClass('hidden');
        $('#liSignIn').addClass('hidden');
        setMenuProfile(token);
    } else {
        $(options).addClass('hidden');
        $('#liSignIn').removeClass('hidden');
    }
} 

const setMenu = (params = {}) => {        

    const { token = getAppToken() } = params;

    if (token) {
        if (token.IsAdmin === "True") { // should be token.IsAdmin === "True" Christian wants to test before making change so he doesn't get support calls
            if (token.IsPastor) { // should be token.IsPastor === "True" -- see above
                $('#liSermons').removeClass('hidden');
            }
            $('#liConnect').removeClass('hidden');
            $('#liSchedule').removeClass('hidden');
            $('#liPrayerRequests').removeClass('hidden');
            $('#liGroups').removeClass('hidden');
            $('#liAdmin').removeClass('hidden');
            $('#liReports').removeClass('hidden');
            $('#liAccount').removeClass('hidden');
            $('#liSignIn').addClass('hidden');
 
        } else if (token.GroupLeaderRights.length > 0) { 
            setGroupLeaderPortalMenu(token)
        } else {
            setMemberPortalMenu(token)
        }

        setMenuProfile(token);
        //alert(ctssFormat.getUTCDate());
        //alert(new Date(token.CSExp));
        //alert(ctssFormat.getUTCDate() > new Date(token.CSExp));

        if (getUTCDate() > new Date(token.CSExp)) {        
            (async() => await refreshTokenForSubscriptionStatusAsync({ tokenNm: 'sNotes' }));
        } else {
            getSubscriptionStatusMsg({ token: token });
        }
    }
}

export {
    adminPortalURL,
    appDebugMode,
    baseURL,
    defaultProfileImg,
    entireCongregationGroupID,
    entireCongregationGroupName,
    entireCongregationGroupImgName,
    Features,
    ImgsFolder,
    getImgsBaseURLAsync,
    getImgsFolder,
    getTestFolderParams,
    getAppToken,
    redirectToHomeURL,
    refreshTokenForSubscriptionStatusAsync,
    setAuthHdr,
    setGroupLeaderPortalMenu,
    setMemberPortalMenu,
    setMenu
};